import { assertKitchenResponse } from "../layouts/ecommerce/KDS/kitchenActions";
import { isPendingKitchenJob } from "../layouts/ecommerce/KDS/pendingKitchenDecisions";

export async function loadPendingKitchenNotifications(fetchJobs, { orgId, locationId }, isCurrent = () => true) {
  const jobs = new Map();
  for (let page = 1; page <= 100; page += 1) {
    if (!isCurrent()) return null;
    const response = await fetchJobs({
      orgId, locationId, statuses: ["PENDING"], page, pageSize: 100,
      sortByCreatedDate: "ASCENDING",
    });
    if (!isCurrent()) return null;
    assertKitchenResponse(response);
    const data = response?.data;
    const total = Number(data?.totalResults);
    if (!Array.isArray(data?.results) || data.totalResults == null || !Number.isFinite(total) || total < 0) {
      throw new Error("Unable to verify incoming kitchen orders.");
    }
    const before = jobs.size;
    data.results.forEach((job) => {
      if (!job?.jobId || !Array.isArray(job.tasks)) throw new Error("Incomplete kitchen notification data.");
      jobs.set(String(job.jobId), job);
    });
    if (jobs.size >= total) return [...jobs.values()].filter(isPendingKitchenJob);
    if (jobs.size === before) throw new Error("Incoming kitchen orders could not be fully loaded.");
  }
  throw new Error("Too many pending kitchen orders to load safely.");
}

export const buildKitchenNotifications = (jobs, scope) => jobs.map((job) => {
  const token = job.token ?? job.jobId;
  const source = job.metadata?.tableNumber != null ? `Table ${job.metadata.tableNumber}` : "Kitchen";
  return {
    id: `kitchen:${scope}:${job.jobId}`, jobId: job.jobId,
    type: "KITCHEN_ORDER", filterType: "delivery", title: `New KOT #${token}`,
    description: `${source} · Awaiting kitchen acceptance`,
    source, tags: [source], createdAt: job.created || null, status: "PENDING",
  };
});
